import React, { useState, useEffect } from 'react';
import ManagerService from '../../services/ManagerService'; // Import ManagerService
import { Form, Button, Container, Row, Col } from 'react-bootstrap';

const ThemBKSComponent = () => {
  const [bienKiemSoat, setBienKiemSoat] = useState('');
  const [trongTai, setTrongTai] = useState('');
  const [loaiKetNoi, setLoaiKetNoi] = useState('');
  const [loaiKetNoiChiTiet, setLoaiKetNoiChiTiet] = useState('');
  const [donVi, setDonVi] = useState('');
  const [trongTaiTheoDonGia, setTrongTaiTheoDonGia] = useState('');

  const ketNoiChiTietOptions = {
    "Nội Thành": [{ value: "Nội Thành", text: "Nội Thành" }],
    "Nội Tỉnh": [
      { value: "Bến Tre", text: "Bến Tre" },
      { value: "Bình Dương", text: "Bình Dương" },
      { value: "Bình Phước", text: "Bình Phước" },
      { value: "Đắc Lắc", text: "Đắc Lắc" },
      { value: "Đắc Nông", text: "Đắc Nông" },
      { value: "Đồng Nai", text: "Đồng Nai" },
      { value: "Khánh Hoà", text: "Khánh Hoà" },
      { value: "Lâm Đồng", text: "Lâm Đồng" },
      { value: "Long An", text: "Long An" },
      { value: "Ninh Thuận", text: "Ninh Thuận" },
      { value: "Phú Yên", text: "Phú Yên" },
      { value: "Tây Ninh", text: "Tây Ninh" },
      { value: "Tiền Giang", text: "Tiền Giang" },
      { value: "Vũng Tàu", text: "Vũng Tàu" },
      { value: "Bình Thuận", text: "Bình Thuận" }
    ],
    "Nội Vùng": [{ value: "Nội Vùng", text: "Nội Vùng" }],
    "Bắc Nam": [{ value: "Bắc Nam", text: "Bắc Nam" }]
  };

  const trongTaiOptions = {
    "Nội Thành": [
      { value: "830", text: "830" },
      { value: "900", text: "900" },
      { value: "1250", text: "1250" },
      { value: "1650", text: "1650" },
      { value: "1900", text: "1900" },
      { value: "2500", text: "2500" },
      { value: "3500", text: "3500" },
      { value: "4500", text: "4500" },
      { value: "5100", text: "5100" },
      { value: "6700", text: "6700" },
      { value: "8000", text: "8000" }
    ],
    "Nội Tỉnh": [
      { value: "830", text: "830" },
      { value: "900", text: "900" },
      { value: "1250", text: "1250" },
      { value: "1650", text: "1650" },
      { value: "2500", text: "2500" },
      { value: "3500", text: "3500" },
      { value: "4500", text: "4500" },
      { value: "5100", text: "5100" },
      { value: "13000", text: "13000" }
    ],
    "Nội Vùng": [
      { value: "1250", text: "1250" },
      { value: "1900", text: "1900" },
      { value: "2500", text: "2500" },
      { value: "4500", text: "4500" },
      { value: "8000", text: "8000" },
      { value: "13000", text: "13000" },
      { value: "17900", text: "17900" }
    ],
    "Bắc Nam": [
      { value: "5100", text: "5100" },
      { value: "6700", text: "6700" },
      { value: "8000", text: "8000" },
      { value: "17900", text: "17900" },
      { value: "35000", text: "35000" }
    ]
  };

  // Khi `loaiKetNoi` thay đổi, cập nhật `loaiKetNoiChiTiet` và `trongTaiTheoDonGia`
  useEffect(() => {
    const ketNoiOptions = ketNoiChiTietOptions[loaiKetNoi];
    const trongTaiOptionsList = trongTaiOptions[loaiKetNoi];

    if (ketNoiOptions && ketNoiOptions.length > 0) {
      setLoaiKetNoiChiTiet(ketNoiOptions[0].value); // Cập nhật giá trị đầu tiên của `loaiKetNoiChiTiet`
    } else {
      setLoaiKetNoiChiTiet(''); // Nếu không có tùy chọn, đặt về rỗng
    }

    if (trongTaiOptionsList && trongTaiOptionsList.length > 0) {
      setTrongTaiTheoDonGia(trongTaiOptionsList[0].value); // Cập nhật giá trị đầu tiên của `trongTaiTheoDonGia`
    } else {
      setTrongTaiTheoDonGia(''); // Nếu không có tùy chọn, đặt về rỗng
    }
  }, [loaiKetNoi]);

  const validateBienKiemSoat = () => {
    const regex = /^[A-Z0-9]+-[A-Z0-9]+$/;
    if (!regex.test(bienKiemSoat)) {
      alert('Biển kiểm soát không hợp lệ!');
      setBienKiemSoat('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      bien_kiem_soat: bienKiemSoat,
      trong_tai: trongTai,
      loai_ket_noi: loaiKetNoi,
      don_vi: donVi,
      loai_ket_noi_chi_tiet: loaiKetNoiChiTiet,
      trong_tai_theo_don_gia: trongTaiTheoDonGia
    };

    try {
      const result = await ManagerService.submitNhapBKS(formData); // Gọi API thông qua ManagerService
      alert(result.message); // Hiển thị thông báo từ server
    } catch (error) {
      console.error('Lỗi:', error);
      alert('Gửi yêu cầu thất bại.');
    }
  };

  return (
    <Container fluid={true}>
      <h2 className="text-center my-4">Nhập thông tin biển kiểm soát</h2>
      <Form onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="bienKiemSoat">
              <Form.Label>Biển kiểm soát</Form.Label>
              <Form.Control
                type="text"
                value={bienKiemSoat}
                onChange={(e) => setBienKiemSoat(e.target.value.toUpperCase())}
                onBlur={validateBienKiemSoat}
                required
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group controlId="trongTai">
              <Form.Label>Trọng tải của xe (Kg)</Form.Label>
              <Form.Control
                type="number"
                value={trongTai}
                onChange={(e) => setTrongTai(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="loaiKetNoi">
              <Form.Label>Loại kết nối</Form.Label>
              <Form.Select
                value={loaiKetNoi}
                onChange={(e) => setLoaiKetNoi(e.target.value)}
                required
              >
                <option value="" disabled>Chọn loại kết nối</option>
                <option value="Nội Thành">Nội Thành</option>
                <option value="Nội Tỉnh">Nội Tỉnh</option>
                <option value="Nội Vùng">Nội Vùng</option>
                <option value="Bắc Nam">Bắc Nam</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group controlId="donVi">
              <Form.Label>Đơn vị</Form.Label>
              <Form.Select
                value={donVi}
                onChange={(e) => setDonVi(e.target.value)}
                required
              >
                <option value="" disabled>Chọn đơn vị</option>
                <option value="HCM">HCM</option>
                <option value="KT3">KT3</option>
                <option value="KD">KD</option>
                <option value="TN">Thuê Ngoài</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="loaiKetNoiChiTiet">
              <Form.Label>Loại kết nối chi tiết</Form.Label>
              <Form.Select
                value={loaiKetNoiChiTiet}
                onChange={(e) => setLoaiKetNoiChiTiet(e.target.value)}
                required
              >
                {ketNoiChiTietOptions[loaiKetNoi]?.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.text}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group controlId="trongTaiTheoDonGia">
              <Form.Label>Trọng tải theo đơn giá</Form.Label>
              <Form.Select
                value={trongTaiTheoDonGia}
                onChange={(e) => setTrongTaiTheoDonGia(e.target.value)}
                required
              >
                {trongTaiOptions[loaiKetNoi]?.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.text}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <Button type="submit" variant="danger">
          Xác nhận
        </Button>
      </Form>
    </Container>
  );
};

export default ThemBKSComponent;